import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { injectIntl } from "gatsby-plugin-intl"
import Img from "gatsby-image"

const AboutLeadership = ( { intl } ) => {
  const assets = useStaticQuery(
    graphql`
      query getLeaders {
        ceo: file( relativePath: { eq: "about/ceo.jpg" } ) {
          ...square
        },
        business: file( relativePath: { eq: "about/business.jpg" } ) {
          ...square
        },
        strategy: file( relativePath: { eq: "about/strategy.jpg" } ) {
          ...square
        },
        designDirector: file( relativePath: { eq: "about/design-director.jpg" } ) {
          ...square
        },
        finance: file( relativePath: { eq: "about/finance.jpg" } ) {
          ...square
        },
        ti: file( relativePath: { eq: "about/ti.jpg" } ) {
          ...square
        },
        designLead: file( relativePath: { eq: "about/design-lead.jpg" } ) {
          ...square
        },
        seniorUX1: file( relativePath: { eq: "about/senior-ux-1.jpg" } ) {
          ...square
        },
        seniorUX2: file( relativePath: { eq: "about/senior-ux-2.jpg" } ) {
          ...square
        }
      }
    `
  )
  return [
    <div key="text" className="block text leadership">
      <label className="label hidden">{ intl.formatMessage( { id: "about.leadership.label" } ) }</label>
      <div className="content text hidden">
        <h2 className="title hidden">{ intl.formatMessage( { id: "about.leadership.title" } ) }</h2>
        <p>{ intl.formatMessage( { id: "about.leadership.text" } ) }</p>
      </div>
    </div>,
    <ol key="list" className="block image leaders">
      <li className="leader hidden">
        <Img fluid={ assets.ceo.childImageSharp.fluid } />
        Maria Ercilia Galvão Bueno
        <small>{ intl.formatMessage( { id: "leaders-label.ceo" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.business.childImageSharp.fluid } />
        Rafael Rezende
        <small>{ intl.formatMessage( { id: "leaders-label.business" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.strategy.childImageSharp.fluid } />
        Bruno Canato
        <small>{ intl.formatMessage( { id: "leaders-label.strategy" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.designDirector.childImageSharp.fluid } />
        Fernando Paravela
        <small>{ intl.formatMessage( { id: "leaders-label.design-director" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.finance.childImageSharp.fluid } />
        Samara Paz
        <small>{ intl.formatMessage( { id: "leaders-label.finance" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.ti.childImageSharp.fluid } />
        Viviane de Lucca
        <small>{ intl.formatMessage( { id: "leaders-label.ti" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.designLead.childImageSharp.fluid } />
        Marcelo Prati
        <small>{ intl.formatMessage( { id: "leaders-label.design-lead" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.seniorUX1.childImageSharp.fluid } />
        Daniella Parra
        <small>{ intl.formatMessage( { id: "leaders-label.senior-ux-1" } ) }</small>
      </li>
      <li className="leader hidden">
        <Img fluid={ assets.seniorUX2.childImageSharp.fluid } />
        Viktor Eisenmann
        <small>{ intl.formatMessage( { id: "leaders-label.senior-ux-2" } ) }</small>
      </li>
    </ol>
  ]
}

const inject = injectIntl( AboutLeadership )
export { inject as AboutLeadership }
